export default "__VITE_ASSET__CYr7iYxP__"